/** @format */

import {toggleArrayValue} from 'helpers/arrayHelpers';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

interface Options {
  data: Space;
  chartId: ChartIds;
}

const updateBoardWidgets = ({data, chartId}: Options): Space => {
  const newSelected = toggleArrayValue(data.widgetsBoardSelected, chartId);

  return {
    ...data,
    widgetsBoardSelected: newSelected,
  };
};

export default updateBoardWidgets;
